import { getAmplitudeInstance } from '../amplitudeHelpers';
import OSMCTA from '../enums/OSMCTA';
import PoiLocation from '../enums/PoiLocation';

type logOSMCTAClickedParams = {
  osm_category?: string;
  osm_cta: OSMCTA;
  osm_lat?: number;
  osm_lng?: number;
  osm_name?: string;
  poi_location?: PoiLocation;
};

/**
 * User taps the primary CTA inside the popover for an OSM-sourced POI on a map. The CTA label depends on surface: 'Add to route' inside the custom route editor; 'Build custom route' on the explore, navigator, and trail detail maps.
 * @param params - Attributes to log with the amplitude event
 * @param params.osm_category - OSM tag category of the clicked POI. Examples include mountain, campsite, waterfall, &tc.
 * @param params.osm_cta - The CTA variant the user tapped.
 * @param params.osm_lat - Latitude of the OSM POI. Null if unavailable.
 * @param params.osm_lng - Longitude of the OSM POI. Null if unavailable.
 * @param params.osm_name - Display name of the OSM POI. Null when the OSM point has no name (compact popover variant was rendered).
 * @param params.poi_location - The map surface on which the popover appeared (e.g. explore map, custom route builder, navigator map, trail page).
 */
const logOSMCTAClicked = ({ osm_category, osm_cta, osm_lat, osm_lng, osm_name, poi_location }: logOSMCTAClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'osm cta clicked',
    { 'osm category': osm_category, 'osm cta': osm_cta, 'osm lat': osm_lat, 'osm lng': osm_lng, 'osm name': osm_name, 'poi location': poi_location },
    callback
  );
};

export default logOSMCTAClicked;
